import {Transport, TransportEntity} from "../../../model/transport";
import {createParamSelector, getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";
import {TransportCategory} from "../../../model/transport-category";

export interface TransportSelectorProps {
  regionId?: string
  category?: TransportCategory
}

const getRegionIdParam = createParamSelector<TransportSelectorProps | undefined, string | undefined>(params => params?.regionId);
const getCategoryParam = createParamSelector<TransportSelectorProps | undefined, TransportCategory | undefined>(params => params?.category);

export const transportsSelector = () => createSelector(
  [getUseQueryResultData<Transport[]>, getRegionIdParam, getCategoryParam],
  (data, regionId, category) => {
    return selectTransportsAndTransform(
      data ?? [], {
        regionId: regionId,
        category: category,
      }
    );
  }
);

export const transportSelector = () => createSelector(
  [getUseQueryResultData<Transport>],
  (data) => {
    return data ? transformTransport(data) : undefined;
  }
);

export const selectTransports = (values?: Transport[], selector?: TransportSelectorProps): Transport[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;

    if (selector?.regionId) {
      if (v.regionId !== selector.regionId) {
        filterIn = false;
      }
    }

    if (selector?.category) {
      if (v.category !== selector.category.code) {
        filterIn = false;
      }
    }

    return filterIn;
  });
};

export const transformTransport = (value: Transport): TransportEntity => {
  return TransportEntity.from(value)
}

export const selectTransportsAndTransform = (values?: Transport[], selector?: TransportSelectorProps): TransportEntity[] => {
  const selected = selectTransports(values, selector);
  return selected.map(transformTransport);
};
